import React, { useEffect } from "react";
import { Box, Button, Menu, Portal, Text } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { ChevronDown, Download, FileSpreadsheet, FileText, Save } from "lucide-react";
import {
  downloadReport,
  updateDownloadingReport,
} from "../store/actions/subscriptionsActions";

const DownloadReport = ({
  reportRange,
  reportTypeId,
  renderConfig = null,
  onSave,
  isSaving = false,
  onDownloadCsv,
}) => {
  const { organizationId, branchId, dateRange } = useSelector(
    (state) => state.defaultReducer
  );
  const { downloadingReport } = useSelector(
    (state) => state.subscriptionsReducer
  );
  const dispatch = useDispatch();
  const data = {
    organizationId,
    branchId,
    dateRange,
    reportTypeId,
    reportRange,
    renderConfig,
  };
  const hasMenuActions = Boolean(onSave || onDownloadCsv);

  const downloadPdf = () => {
    dispatch(downloadReport(data));
  };

  useEffect(() => {
    dispatch(updateDownloadingReport(false));
  }, []);

  if (hasMenuActions) {
    return (
      <Box>
        <Menu.Root>
          <Menu.Trigger asChild>
            <Button className="downloadButton" loading={downloadingReport} size="md" px="10px">
              <Download />
              {downloadingReport ? "Working..." : "Report Actions"}
              <ChevronDown size={16} />
            </Button>
          </Menu.Trigger>
          <Portal>
            <Menu.Positioner>
              <Menu.Content bg="white" borderColor="var(--borderGrey)">
                {onSave ? (
                  <Menu.Item onClick={onSave} disabled={isSaving}>
                    <Save size={15} />
                    {isSaving ? "Saving..." : "Save"}
                  </Menu.Item>
                ) : null}
                <Menu.Item onClick={downloadPdf}>
                  <FileText size={15} />
                  Download PDF
                </Menu.Item>
                {onDownloadCsv ? (
                  <Menu.Item onClick={onDownloadCsv}>
                    <FileSpreadsheet size={15} />
                    <Box>
                      <Text as="span" display="block">
                        Download CSV
                      </Text>
                      <Text as="span" display="block" fontSize="11px" color="gray.500">
                        Full Excel data; hidden presentation columns stay included.
                      </Text>
                    </Box>
                  </Menu.Item>
                ) : null}
              </Menu.Content>
            </Menu.Positioner>
          </Portal>
        </Menu.Root>
      </Box>
    );
  }

  return (
    <Box>
      <Button
        className="downloadButton"
        loading={downloadingReport}
        size="md"
        px="10px"
        onClick={downloadPdf}
      >
        <Download />
        {downloadingReport ? "Downloading..." : "Download"}
      </Button>
    </Box>
  );
};

export default DownloadReport;
